export default __webpack_public_path__ + "static/media/sign-in-background.00261603.jpg";